/* eslint-disable import/prefer-default-export */
import { colors, type ColorName } from './colors';

export function isColorName(color: string): color is ColorName {
  return Object.keys(colors).includes(color);
}
